import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useCallback, useMemo, useState } from "react";
import PictureComponent from "components/core/picture/picture-component";
import { StyledTagsAndAssetsComponent } from "./tags-and-assets-component.scss";
import ClickableTagsGrid from "segments/desktop/core-components/clickable-tags-grid/clickable-tags-grid";
const TagsAndAssetsComponent = ({ tagsTitle, tags, defaultImage, onClustersChange })=>{
    const [latestSelectedTab, setLatestSelectedTab] = useState(null);
    const tagAssets = useMemo(()=>tags === null || tags === void 0 ? void 0 : tags.map(({ tagImage })=>tagImage), [
        tags
    ]);
    const onTagSelectionChange = useCallback((selectedTags)=>{
        setLatestSelectedTab(selectedTags[selectedTags.length - 1] || null);
        onClustersChange(selectedTags);
    }, []);
    return /*#__PURE__*/ _jsxs(StyledTagsAndAssetsComponent, {
        className: "tags-and-assets-component",
        children: [
            /*#__PURE__*/ _jsx(ClickableTagsGrid, {
                onTagSelectionChange: onTagSelectionChange,
                tags: tags,
                tagsTitle: tagsTitle
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "assets-container",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("default-asset", {
                            active: !latestSelectedTab
                        }),
                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                            src: defaultImage === null || defaultImage === void 0 ? void 0 : defaultImage.src
                        })
                    }),
                    tagAssets === null || tagAssets === void 0 ? void 0 : tagAssets.map((tagAsset, index)=>/*#__PURE__*/ _jsx("div", {
                            className: classnames("picture-wrapper", {
                                selected: latestSelectedTab === tags[index]
                            }),
                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                src: (tagAsset === null || tagAsset === void 0 ? void 0 : tagAsset.src) || (defaultImage === null || defaultImage === void 0 ? void 0 : defaultImage.src)
                            }, index)
                        }))
                ]
            })
        ]
    });
};
export default TagsAndAssetsComponent;
